/* External */
import { all, call, fork, put, select, take, takeLatest } from "redux-saga/effects";

/* Actions */
import { actionTypes as assetActionTypes, fetchPlayerAsset } from "./asset/actions";
import { fetchEntitlementsToken } from "./entitlementsToken/actions";
import { actionTypes as heartbeatActionTypes, pulseStreamHeartbeat } from "./heartbeat/actions";
import { actionTypes } from "./actions";
import { actionTypes as epgActionTypes } from "../epg/stationsWithSchedules/actions";
import { actionTypes as pdpActionTypes } from "../pdp/actions";

/* Sagas */
import asset from "./asset/sagas";
import content, { getPlayerContent } from "./content/sagas";
import entitlementsToken from "./entitlementsToken/sagas";
import heartbeat from "./heartbeat/sagas";

/* Others */
import { HEARTBEAT_PULSE_TYPES, PDP_ASSET_TYPES, STATUS_TYPES } from "../../utils";

function* player({ payload }) {
  const { assetType, isReadyToPlay } = payload;
  const isLive = assetType === PDP_ASSET_TYPES.live;
  const newPayload = { ...payload, isLive };
  const epgStatus = yield select((state) => state.epg.stationsWithSchedules.status);
  const pdpStatus = yield select((state) => state.pdp.status);
  const contentStatus = yield select((state) => state.player.content.status);
  const heartbeatStatus = yield select((state) => state.player.heartbeat.status);

  // Ensure heartbeat is stopped so there is no concurrency errors
  if (heartbeatStatus !== STATUS_TYPES.UNLOAD_STATE) yield take(heartbeatActionTypes.RESET);

  // Send stop heartbeat even if player is not ready to play so there is no concurrency errors
  if (!isReadyToPlay && contentStatus === STATUS_TYPES.SUCCEED_STATE) {
    yield put(pulseStreamHeartbeat({ isLive, pulseAction: HEARTBEAT_PULSE_TYPES.STOP }));
  }

  if (isLive) {
    if (STATUS_TYPES.SUCCEED_STATE !== epgStatus) yield take(epgActionTypes.SUCCESS);
  } else {
    if (STATUS_TYPES.SUCCEED_STATE !== pdpStatus) yield take(pdpActionTypes.SUCCESS);
  }

  yield call(getPlayerContent, newPayload);
  yield put(fetchPlayerAsset(newPayload));
  yield take(assetActionTypes.SUCCESS);
  yield put(fetchEntitlementsToken(newPayload));
}

export default function* () {
  yield all([
    fork(asset),
    fork(content),
    fork(entitlementsToken),
    fork(heartbeat),
    takeLatest(actionTypes.FETCH, player)
  ]);
}
